export type CasoReal = {
  slug: string;
  cliente: string;
  rubro: string;
  producto: string;
  productoId: string;
  destino: string;
  resumen: string;
  entrega: string[];
  imagen: string;
  alt: string;
  secundaria?: { imagen: string; alt: string };
  testimonio?: { autor: string; texto: string; url?: string };
};

export const casosReales: CasoReal[] = [
  {
    slug: "coni-nails-stand-nfc-resenas-google",
    cliente: "Coni Nails",
    rubro: "Belleza y cuidado personal",
    producto: "Stand Google negro NFC + QR",
    productoId: "stand-google",
    destino: "Reseñas de Google",
    resumen:
      "Un stand de sobremesa para que las clientas de Coni Nails puedan llegar directamente al formulario de reseña de Google con NFC o QR.",
    entrega: [
      "Stand Google negro para el punto de atención.",
      "Chip NFC y código QR configurados con el enlace del negocio.",
      "Prueba de funcionamiento antes de la entrega.",
    ],
    imagen: "/clientes/stand-nfc-qr-coni-nails.jpg",
    alt: "Stand negro NFC + QR de reseñas en Google sostenido por Constanza de Coni Nails",
    testimonio: {
      autor: "Constanza Alarcon Lizana",
      texto:
        "Muy buen servicio de Álvaro, fue claro en todo el proceso y bien comprometido. Las valoraciones de mi negocio han subido.",
      url: "https://www.google.com/maps/contrib/102462635804260581420/reviews?authuser=7&hl=es-419",
    },
  },
  {
    slug: "festa-gelateria-stand-nfc-resenas-google",
    cliente: "Festa Gelateria",
    rubro: "Gastronomía",
    producto: "Stand Google blanco NFC + QR",
    productoId: "stand-google-blanco",
    destino: "Reseñas de Google",
    resumen:
      "Un stand blanco instalado en el mesón de Festa Gelateria para dejar el acceso a las reseñas visible en el momento de atención.",
    entrega: [
      "Stand Google blanco para uso sobre el mesón.",
      "Acceso mediante NFC y alternativa con código QR.",
      "Enlace del negocio configurado y comprobado.",
    ],
    imagen: "/clientes/stand-nfc-qr-festa-gelateria.webp",
    alt: "Stand blanco NFC + QR para reseñas de Google en el mesón de Festa Gelateria",
  },
  {
    slug: "kantu-food-stands-nfc-resenas-google",
    cliente: "Kantu Food",
    rubro: "Restaurante",
    producto: "2 stands Google blancos NFC + QR",
    productoId: "stand-google-blanco",
    destino: "Reseñas de Google",
    resumen:
      "Kantu Food recibió dos stands blancos para disponer el acceso a sus reseñas de Google en más de un punto de atención del restaurante.",
    entrega: [
      "Dos stands Google blancos.",
      "NFC y QR conectados al perfil acordado.",
      "Configuración y comprobación antes de entregar.",
    ],
    imagen: "/clientes/stand-nfc-qr-kantu-food.webp",
    alt: "Dos stands blancos NFC + QR para reseñas de Google entregados a Kantu Food",
  },
  {
    slug: "lavaseco-seven-clean-stand-nfc-resenas-google",
    cliente: "Lavaseco Seven Clean",
    rubro: "Lavandería y cuidado de prendas",
    producto: "Stand Google NFC + QR",
    productoId: "stand-google-blanco",
    destino: "Reseñas de Google",
    resumen:
      "Un acceso directo a las reseñas de Google instalado en el punto de atención de Lavaseco Seven Clean, acompañado de un formato portátil.",
    entrega: [
      "Stand NFC + QR para el mesón de atención.",
      "Formato portátil para mostrar el acceso dentro del local.",
      "Enlace configurado y probado antes de la entrega.",
    ],
    imagen: "/clientes/stand-nfc-qr-lavaseco-seven-clean.webp",
    alt: "Stand NFC + QR de reseñas en Google sobre el mesón de Lavaseco Seven Clean",
    secundaria: {
      imagen: "/clientes/stand-nfc-qr-lavaseco-seven-clean-2.webp",
      alt: "Tarjeta NFC + QR de reseñas en Google sostenida dentro de Lavaseco Seven Clean",
    },
    testimonio: {
      autor: "Youlis Mujica",
      texto: "100% recomendado, excelente experiencia.",
    },
  },
  {
    slug: "moscowa-restobar-stand-nfc-resenas-google",
    cliente: "Moscowa Restobar",
    rubro: "Restobar",
    producto: "Stand Google NFC + QR",
    productoId: "stand-google-blanco",
    destino: "Reseñas de Google",
    resumen:
      "Un stand instalado sobre la barra de Moscowa Restobar para acercar a sus clientes al formulario de reseña de Google.",
    entrega: [
      "Stand NFC + QR para uso sobre la barra.",
      "Acceso conectado a las reseñas de Google del negocio.",
      "Configuración comprobada antes de la entrega.",
    ],
    imagen: "/clientes/stand-nfc-qr-moscowa-restobar.webp",
    alt: "Stand NFC + QR de reseñas en Google sobre la barra de Moscowa Restobar",
    testimonio: {
      autor: "Richard Serrano",
      texto: "Excelente producto, funciona perfectamente. Configuración en segundos.",
    },
  },
  {
    slug: "bgo-stand-nfc-qr-instagram",
    cliente: "BGO",
    rubro: "Tienda",
    producto: "Stand Instagram NFC + QR",
    productoId: "stand-instagram",
    destino: "Perfil de Instagram",
    resumen:
      "Un stand frente a la vitrina de BGO configurado como acceso directo a su perfil de Instagram mediante NFC y QR.",
    entrega: [
      "Stand Instagram para el punto de atención.",
      "NFC y QR conectados al perfil del negocio.",
      "Acceso probado antes de la entrega.",
    ],
    imagen: "/clientes/stand-nfc-qr-bgo.webp",
    alt: "Stand NFC + QR de Instagram frente a la vitrina de la tienda BGO",
  },
  {
    slug: "intensos-parfums-stand-nfc-resenas-google",
    cliente: "Intensos Parfums",
    rubro: "Perfumería",
    producto: "Stand Google NFC + QR",
    productoId: "stand-google-blanco",
    destino: "Reseñas de Google",
    resumen:
      "Un stand para reseñas de Google presentado frente a la tienda Intensos Parfums y listo para usar con NFC o QR.",
    entrega: [
      "Stand Google para exhibir en el negocio.",
      "Chip NFC y código QR configurados.",
      "Prueba del enlace antes de entregar.",
    ],
    imagen: "/clientes/stand-nfc-qr-intensos-parfums.webp",
    alt: "Stand NFC + QR de reseñas en Google frente a la tienda Intensos Parfums",
  },
  {
    slug: "muuy-mucho-stand-nfc-qr-instagram",
    cliente: "Muuy Mucho",
    rubro: "Tienda",
    producto: "Stand Instagram NFC + QR",
    productoId: "stand-instagram",
    destino: "Perfil de Instagram",
    resumen:
      "Un stand ubicado en el mostrador de Muuy Mucho para compartir su perfil de Instagram directamente con los clientes.",
    entrega: [
      "Stand Instagram para el mostrador.",
      "Conexión mediante NFC y alternativa con QR.",
      "Perfil del negocio configurado y comprobado.",
    ],
    imagen: "/clientes/stand-nfc-qr-muuy-mucho.webp",
    alt: "Stand NFC + QR de Instagram en el mostrador de la tienda Muuy Mucho",
  },
  {
    slug: "tattoo-piercing-stand-nfc-resenas-google",
    cliente: "Tattoo Piercing",
    rubro: "Estudio de tatuajes y piercing",
    producto: "Stand Google NFC + QR",
    productoId: "stand-google-blanco",
    destino: "Reseñas de Google",
    resumen:
      "Un stand NFC + QR entregado e instalado dentro del estudio Tattoo Piercing para facilitar el acceso a sus reseñas.",
    entrega: [
      "Stand para el punto de atención del estudio.",
      "Enlace de Google configurado en NFC y QR.",
      "Entrega e instalación en el local.",
    ],
    imagen: "/clientes/stand-nfc-qr-tattoo-piercing.webp",
    alt: "Stand NFC + QR de reseñas en Google dentro del estudio Tattoo Piercing",
    secundaria: {
      imagen: "/clientes/stand-nfc-qr-tattoo-piercing-fachada.webp",
      alt: "Fachada e ingreso del estudio Tattoo Piercing",
    },
  },
  {
    slug: "tencha-matcheria-stand-nfc-resenas-google",
    cliente: "Tencha Matcheria",
    rubro: "Cafetería y matcha",
    producto: "Stand Google NFC + QR",
    productoId: "stand-google-blanco",
    destino: "Reseñas de Google",
    resumen:
      "Un stand para reseñas de Google instalado en el mesón de atención de Tencha Matcheria, visible al finalizar la compra.",
    entrega: [
      "Stand Google para el mesón de atención.",
      "NFC y QR conectados al enlace acordado.",
      "Funcionamiento comprobado antes de la entrega.",
    ],
    imagen: "/clientes/stand-nfc-qr-tencha-matcheria.webp",
    alt: "Stand NFC + QR de reseñas en Google en el mesón de atención de Tencha Matcheria",
  },
];

export function buscarCaso(slug: string) {
  return casosReales.find((caso) => caso.slug === slug);
}
